import {
  borderRadius,
  breakpoint,
  colors,
  fontFamily,
  fontSize,
  fontWeight,
  mediaQueryHelper,
  shorthandHelper,
  spacing,
} from '@offerzen/pinata'
import { css } from '@emotion/css'

const CUSTOM_BREAKPOINT = 321

const styles = {
  filterBlock: css({
    marginRight: 0,
    paddingBottom: 18,
    width: '100%',
    maxWidth: 'unset',

    [mediaQueryHelper(breakpoint.phone)]: {
      paddingBottom: 18,
      maxWidth: 'unset',
      flex: 'unset',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      paddingBottom: 0,
      maxWidth: '200px',
      flex: 'unset',
    },
  }),

  label: css({
    fontWeight: fontWeight.regular,
    color: colors.white,
    fontSize: fontSize.default,
    display: 'block',
    marginBottom: spacing.small,

    [mediaQueryHelper(breakpoint.tablet)]: {
      fontSize: fontSize.small,
      color: colors.scorpion,
    },
  }),

  filterInputWrapper: css({
    position: 'relative',
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.grayChateau}`,
    width: '100%',
    height: 45,
    boxSizing: 'border-box',

    '&:focus': {
      outline: 'none',
      backgroundColor: colors.porcelain,
    },

    '&:hover': {
      backgroundColor: colors.porcelain,
    },
  }),

  filterInput: css({
    all: 'unset',
    borderColor: colors.geyser,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, spacing.default]),
    appearance: 'none',
    border: 'none',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    borderRadius: borderRadius.default,
    backgroundColor: colors.white,
    cursor: 'pointer',
    color: colors.grayChateau,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  }),

  filterInputFilled: css({
    fontWeight: fontWeight.semiBold,
    color: colors.scorpion,
  }),

  modal: css({
    height: '200px',
    paddingBottom: '50px',
    top: 'calc(100% - 18px)',

    [mediaQueryHelper(CUSTOM_BREAKPOINT)]: {
      height: '280px',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      height: '235px',
      width: '280px',
      left: 0,
      top: '100%',
      paddingBottom: '10px',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      width: '350px',
    },
  }),

  error: css({
    borderColor: colors.mandy,
  }),

  errorMessage: css({
    position: 'relative',
    fontSize: fontSize.extraSmall,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.2,
    marginTop: 3,
    color: colors.mandy,
    whiteSpace: 'nowrap',

    [mediaQueryHelper(breakpoint.phone)]: {
      position: 'absolute',
    },
  }),
}

export default styles
